const tg = window.Telegram.WebApp;

export function useTelegram() {

    const onClose = () => {
        tg.close()
    }

    const onToggleButton = () => {
        if(tg.MainButton.isVisible) {
            tg.MainButton.hide();
        } else {
            tg.MainButton.show();
        }
    }

    const onExpand = () => {
        tg.expand()
    }

    const onReady = () => {
        tg.ready();
    }

    const onSetHeaderColor = () => {
        tg.setHeaderColor("#ffffff");
    }

    const onSetBottomBarColor = () => {
        tg.setBottomBarColor("#ffffff");
    }

    const onDisableVerticalSwipes = () => {
        tg.disableVerticalSwipes()
    }

    return {
        onClose,
        onToggleButton,
        onExpand,
        onDisableVerticalSwipes,
        onSetHeaderColor,
        onSetBottomBarColor,
        onReady,
        tg,
        user: tg.initDataUnsafe?.user,
        queryId: tg.initDataUnsafe?.query_id,
        photo_url: tg.initDataUnsafe?.photo_url
    }
}
